<div class="d-flex align-items-center" mat-dialog-title>
    <div class="spacer title">Inhuur bedrijven</div>
    <div>
        <button (click)="close()" mat-icon-button tabindex="-1"><i class="fas fa-times"></i></button>
    </div>
</div>
@if (!selectedWeek) {
    <div mat-dialog-content>
        <h2>Kies een week</h2>
        <table class="table table-bordered table-striped text-right table-hover">
            <thead>
                <tr>
                    <th class="text-center" width="70">Week</th>
                    <th>Van</th>
                    <th>Tot</th>
                </tr>
            </thead>
            @for (week of weeks; track week) {
                <tr class="curpoint" (click)="showHire(week)">
                    <td class="text-center">{{ week.startDate | date: 'w' }}</td>
                    <td>
                        {{ week.startDate | date: 'EEE d MMM y' }}
                    </td>
                    <td>
                        {{ week.endDate | date: 'EEE d MMM y' }}
                    </td>
                </tr>
            }
        </table>
        <i>Het is vandaag {{ today | date: 'EEEE d MMMM y' }}</i>
    </div>
} @else if (selectedWeek) {
    <div mat-dialog-content>
        <div class="d-flex align-items-center">
            <button (click)="selectedWeek = null" color="primary" mat-icon-button tabindex="-1">
                <i class="fas fa-chevron-left"></i>
            </button>
            <h2 class="mb-0">Inhuur week {{ selectedWeek.startDate | date: 'w' }}</h2>
        </div>
        <table class="table table-bordered table-striped table-hover">
            @for (hire of hirePerCompany; track hire) {
                <tr>
                    <th>
                        <span class="curpoint" (click)="copyToClipboard(hire.company?.name)">{{
                            hire.company?.name
                        }}</span>
                        -
                        <span class="curpoint" (click)="copyToClipboard(hire.company?.phone)">{{
                            hire.company?.phone
                        }}</span>
                        -
                        <span class="curpoint" (click)="copyToClipboard(hire.company?.email)">{{
                            hire.company?.email
                        }}</span>
                    </th>
                </tr>
                <tr>
                    <td class="curpoint" #item (click)="copyToClipboard(item.innerHTML)">
                        <p>Week {{ selectedWeek.startDate | date: 'w' }}</p>
                        @for (hired of hire.hiring; track hired) {
                            <b
                                >{{ hired.hired.begindate | date: 'EEEE d MMMM' }}
                                {{ hired.hired.entity['entitytype']?.name }} {{ hired.hired?.name }}</b
                            ><br />
                            {{ hired.hired.comment }}
                            <ul>
                                <li
                                    [style.color]="
                                        (hired.hired.begindate | isNight: hired.hired.enddate) ? '#F00' : ''
                                    ">
                                    Werk van {{ hired.hired.begindate | date: 'HH:mm' }} tot
                                    {{ hired.hired.enddate | date: 'HH:mm' }}
                                </li>
                                <li>Locatie: {{ hired.planning.location }}</li>
                                <li>
                                    {{ environment.executorName | ucFirst }}: {{ hired.performer?.name }}
                                    {{ hired.performer?.phone }}
                                </li>
                                <li>Werknummer: {{ hired.planning.worknumber ?? hired.planning.afas_project_id }}</li>
                                @if (hired.hired?.lowloader_entity_id) {
                                    <li>Dieplader: {{ hired.hired?.lowloader_entity?.name }}</li>
                                }
                            </ul>
                        }
                    </td>
                </tr>
            }
        </table>
    </div>
}
